// extracted by mini-css-extract-plugin
export var authorCard = "Q_cy";
export var authorCardContent = "Q_cB";
export var authorCardImage = "Q_cz";
export var bottom = "Q_cH";
export var description = "Q_cG";
export var name = "Q_cD";
export var role = "Q_cF";
export var top = "Q_cC";